import React, { useState } from "react";
import "./Register.css";
import FormPopup from "../Popup/FormPopup";
import closeBtn from "../../images/close-btn.svg";

const Register = ({ isRegisterPopup, setIsRegisterPopup }) => {
  const [isRegisterFormSend, setIsRegisterFormSend] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    repeatPassword: "",
  });

  const handleChange = (e) => {
    const { value, name } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setFormData({ email: "", password: "", repeatPassword: "" });
    setIsRegisterFormSend(true);
  };

  return (
    isRegisterPopup && (
      <div className="popup">
        <form
          onSubmit={handleSubmit}
          className={`lottolegenda-contact__form ${
            isRegisterFormSend && "hidden-popup"
          }`}
        >
          <button
            className="lottolegenda-contact__close"
            onClick={() => setIsRegisterPopup(false)}
          >
            <img src={closeBtn} alt="close btn" title="close btn" />
          </button>
          <h2 className="text-center upper col-white lottolegenda-form__header">
            sign up
          </h2>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Enter e-mail"
            className="lottolegenda-form__input"
          />
          <input
            type="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            placeholder="Enter password"
            className="lottolegenda-form__input"
          />
          <input
            type="password"
            name="repeatPassword"
            value={formData.repeatPassword}
            onChange={handleChange}
            placeholder="Repeat assword"
            className="lottolegenda-form__input"
          />
          <button
            type="submit"
            className="lottolegenda-popup__btn lottolegenda-popup__btn-main upper t-21 fw-700"
          >
            Sign up
          </button>
        </form>
        <FormPopup
          isFormSend={isRegisterFormSend}
          fn={setIsRegisterPopup}
          fnTwo={setIsRegisterFormSend}
        />
      </div>
    )
  );
};

export default Register;
